/*
  usePrevious.js
*/

// Npm.
import { useRef } from 'react';

/**
 * Returns the previous value supplied, or null if none.
 */
export default function usePrevious(value) {

  const currRef = useRef(null);
  const prevRef = useRef(null);

  if (value !== currRef.current) {
    prevRef.current = currRef.current;
    currRef.current = value;
  }

  return prevRef.current;

}
